import { useState, useEffect } from "react";
import { portfolio } from "../constants";
import Heading from "./Heading";
import Section from "./Section";

const Portfolio = () => {
  const [responsiveImages, setResponsiveImages] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      const updatedImages = portfolio.map((item) => ({
        id: item.id,
        imageUrl: window.innerWidth < 640 ? item.smallImageUrl : item.imageUrl,
      }));
      setResponsiveImages(updatedImages);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Section id="works" crosses>
      <div className="container">
        <Heading
          className="md:max-w-md lg:max-w-2xl"
          title="Our Works"
          tag="Web Wonders, Brand Brilliance, Digital Dominance."
        />

        <div
          role="list"
          className="flex flex-col gap-y-10 lg:grid lg:grid-cols-2"
        >
          {portfolio.map((item) => {
            const responsiveImage = responsiveImages.find(
              (img) => img.id === item.id,
            );
            const imageUrl = responsiveImage
              ? responsiveImage.imageUrl
              : item.imageUrl;

            return (
              <div
                role="listitem"
                className="grid-portfolio-item mx-auto rounded-[2.5rem] bg-conic-gradient p-0.5 sm:max-w-[36rem] md:max-w-[40rem] lg:max-w-[30rem] xl:max-w-[35rem]"
                key={item.id}
              >
                <div className="grid-col-2 grid h-[100%] rounded-[2.4375rem] bg-black p-4 sm:p-6 md:p-8 xl:p-10">
                  <a
                    href={item.siteUrl}
                    title={item.title}
                    className="grid-portfolio-item-link w-inline-block col-span-2"
                  >
                    <div className="relative portfolio-image-thumb-wrap longThumb mt-2 px-3 pt-3 sm:h-[400px]">
                      <img
                        src={imageUrl}
                        className="portfolio-image-thumb rounded-2xl sm:rounded-none"
                        loading="lazy"
                        title={item.title}
                        alt="Website Image"
                      />
                      {item.inProgress && (
                        <div className="absolute bottom-5 right-5 animate-pulse rounded-md bg-white px-2.5 py-1 text-xs font-bold uppercase text-black">
                          In Progress
                        </div>
                      )}
                    </div>
                    <p className="mb-5 mt-8 h-[36px] overflow-hidden text-center text-2xl font-bold leading-[36px] text-white sm:mb-8 sm:mt-5">
                      {item.title}
                    </p>
                  </a>

                  {/* <div className="grid-portfolio-summary-wrap text-white"> */}
                  <div className="grid-portfolio-summary">
                    <p className="font-semibold">Description</p>
                    <p>
                      <span className="text-sm sm:text-base md:text-lg">
                        {item.text}
                      </span>
                    </p>
                  </div>
                  <div className="grid-portfolio-summary">
                    <p className="font-semibold">Website Type</p>
                    <p>
                      <span className="text-sm sm:text-base md:text-lg lg:text-xl">
                        {item.type}
                      </span>
                    </p>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Section>
  );
};

export default Portfolio;
